import { TagTypes } from '../../../Api/Types/tagTypes';
import type { UnsettleBookingRequest } from '../Types/bookingSettlement.types';

export type BookingTag = {
  type: TagTypes.Booking;
  id: number | TagTypes.List;
};

export const getBookingSettlementUrl = (bookingId: number): string =>
  `/bookings/${bookingId}/accounting-settlement`;

export const buildSettleBookingForAccountingRequest = (
  bookingId: number
): { url: string; method: 'POST' } => ({
  url: `/bookings/${bookingId}/settle-for-accounting`,
  method: 'POST',
});

export const buildUnsettleBookingForAccountingRequest = (
  request: UnsettleBookingRequest
): { url: string; method: 'POST'; body: { reason: string } } => ({
  url: `/bookings/${request.bookingId}/unsettle-for-accounting`,
  method: 'POST',
  body: { reason: request.reason },
});

export const getBookingSettlementProvidesTags = (bookingId: number): BookingTag[] => [
  { type: TagTypes.Booking, id: bookingId },
];

export const getBookingSettlementInvalidatesTags = (bookingId: number): BookingTag[] => [
  { type: TagTypes.Booking, id: bookingId },
  { type: TagTypes.Booking, id: TagTypes.List },
];
